import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import {setDarkMode, setTitle} from './layout.action';
import { ThemeService } from '../../core/services/theme/theme.service';
import {Title} from "@angular/platform-browser";

@Injectable(
  { providedIn: 'root' }
)
export class LayoutEffects {
  constructor(private actions$: Actions, private titleService: Title) { }

  themeService = inject(ThemeService);

  setTitle$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setTitle), // Escucha la acción
        tap((value) => {
          this.titleService.setTitle(value.title);
        })
      ),
    { dispatch: false } // Este efecto no despacha nuevas acciones
  );

  darkMode$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setDarkMode), // Escucha la acción
        tap((value) => {
          this.themeService.setTheme(value.darkMode);
        })
      ),
    { dispatch: false } // Este efecto no despacha nuevas acciones
  );

}
